import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AiAdminService {

  constructor(public hs: HttpService) { }

  async get_login_request_list(filters: any) {
    try {
      return await this.hs.get('/ai-admin/get-login-request-list', filters);
    } catch (error: any) {
      throw error;
    }
  }

  async approve_request(payload: { id: number }) {
    try {
      return await this.hs.post('/ai-admin/approve-login-request', {}, payload);
    } catch (error: any) {
      throw error;
    }
  }

  async reject_request(payload: { id: number; comment?: string }) {
    try {
      return await this.hs.post('/ai-admin/reject-login-request', {}, payload);
    } catch (error: any) {
      throw error;
    }
  }

  async get_ai_logs(filters: any) {
    try {
      return await this.hs.get('/ai-admin/get-ai-logs', filters);
    } catch (error: any) {
      throw error;
    }
  }
}
